<template>
    <div class="bot-manager">
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">


                <el-form-item label="搜索用户">
                    <el-input v-model="searchForm.keyword" placeholder="请输入用户id/昵称/用户名" clearable size="large"
                        style="width: 200px">
                    </el-input>
                </el-form-item>




                <el-form-item>
                    <div class="button-group">
                        <el-button type="primary" @click="onSearch" size="large">
                            <el-icon>
                                <Search />
                            </el-icon>搜索
                        </el-button>
                        <el-button @click="resetSearch" size="large">
                            <el-icon>
                                <Refresh />
                            </el-icon>重置
                        </el-button>

                        <el-button type="warning" @click="handleImport" size="large">
                            <el-icon>
                                <Upload />
                            </el-icon>
                            导入
                        </el-button>
                        <el-button type="info" @click="handleExport" size="large">
                            <el-icon>
                                <Download />
                            </el-icon>
                            导出
                        </el-button>

                    </div>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>


        <el-table :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column prop="userImg" label="用户头像" width="80">
                <template #default="scope">
                    <el-avatar :size="40" :src="scope.row.userImg">
                        <span>{{ scope.row.nickname ? scope.row.nickname.charAt(0).toUpperCase() : 'U' }}</span>
                    </el-avatar>
                </template>
            </el-table-column>

            <el-table-column prop="nickname" label="昵称" min-width="120">
                <template #default="scope">
                    {{ scope.row.nickname || '-' }}
                </template>
            </el-table-column>

            <el-table-column prop="userName" label="Telegram用户名" min-width="150">
                <template #default="scope">
                    {{ scope.row.userName ? '@' + scope.row.userName : '-' }}
                </template>
            </el-table-column>

            <el-table-column prop="userId" label="Telegram用户ID" min-width="150">
                <template #default="scope">
                    {{ scope.row.userId }}
                </template>
            </el-table-column>

            <el-table-column prop="userStatus" label="成员状态" width="120">
                <template #default="scope">
                    <el-tag :type="getStatusType(scope.row.userStatus)">
                        {{ getStatusText(scope.row.userStatus) }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="isBot" label="是否是机器人" width="100">
                <template #default="scope">
                    <el-tag :type="scope.row.isBot ? 'warning' : 'info'">
                        {{ scope.row.isBot ? '是' : '否' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="userPoint" label="积分" width="100" sortable>
                <template #default="scope">
                    {{ scope.row.userPoint || 0 }}
                </template>
            </el-table-column>

            <el-table-column prop="userLevelName" label="等级" width="100">
                <template #default="scope">
                    {{ scope.row.userLevelName || '-' }}
                </template>
            </el-table-column>

            <el-table-column prop="joinTime" label="入群时间" min-width="180" sortable>
                <template #default="scope">{{ formatDateTime(scope.row.joinTime) }}</template>
            </el-table-column>

            <el-table-column label="操作" width="200" fixed="right">
                <template #default="scope">
                    <div class="operation-buttons">
                        <!-- 禁言/解禁按钮 -->
                        <el-button v-if="scope.row.canSendMessage == 1" type="warning" size="small"
                            @click="handleMute(scope.row, 0)">
                            禁言
                        </el-button>
                        <el-button v-if="scope.row.canSendMessage === 0" type="success" size="small"
                            @click="handleMute(scope.row, 1)">
                            解禁
                        </el-button>

                        <!-- 踢出/解封按钮 -->
                        <el-button v-if="scope.row.userStatus !== 'kicked'" type="danger" size="small"
                            @click="handleKick(scope.row, true)">
                            踢出
                        </el-button>
                        <el-button v-if="scope.row.userStatus === 'kicked'" type="success" size="small"
                            @click="handleKick(scope.row, false)">
                            解封
                        </el-button>

                        <el-dropdown @command="handleMoreCommand" style="margin-left: 10px;">
                            <el-button size="small">
                                更多<el-icon class="el-icon--right">
                                    <ArrowDown />
                                </el-icon>
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item
                                        :command="{ action: 'syncStatus', row: scope.row }">同步状态</el-dropdown-item>
                                    <el-dropdown-item
                                        :command="{ action: 'addPoint', row: scope.row }">增加积分</el-dropdown-item>
                                    <el-dropdown-item
                                        :command="{ action: 'subPoint', row: scope.row }">减少积分</el-dropdown-item>
                                    <el-dropdown-item
                                        :command="{ action: 'pointLog', row: scope.row }">积分日志</el-dropdown-item>
                                    <!-- <el-dropdown-item
                                        :command="{ action: 'setLevel', row: scope.row }">指定等级</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </template>
            </el-table-column>
        </el-table>




        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>


        <!-- 导入对话框 -->
        <el-dialog v-model="importVisible" title="导入成员管理数据（JSON格式）" width="600px">
            <el-input type="textarea" v-model="jsonInput" :rows="8" placeholder="可粘贴 JSON 或拖拽上传 .json 文件，将自动提取数组数据"
                style="margin-bottom: 16px;" />
            <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center;">
                <el-button size="small" @click="toggleJsonFormat" :disabled="!jsonInput">
                    <el-icon>
                        <View />
                    </el-icon>
                    {{ isFormatted ? '压缩显示' : '格式化显示' }}
                </el-button>
                <span v-if="previewCount > 0" style="color: #67c23a; font-size: 14px;">
                    已识别到 {{ previewCount }} 条数据
                </span>
            </div>
            <el-upload :show-file-list="false" accept=".json,application/json" :before-upload="handleJsonFile" drag
                class="json-upload-drag">
                <el-icon class="el-icon--upload">
                    <Upload />
                </el-icon>
                <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                </div>
                <template #tip>
                    <div class="el-upload__tip">
                        支持粘贴或上传 JSON 文件，格式如：{ code, data: { records: [...] } }<br>
                        将自动提取数组数据并压缩显示，字段需与导出格式一致。
                    </div>
                </template>
            </el-upload>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="importVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmImport" :loading="importLoading" :disabled="!jsonInput">
                        {{ importLoading ? '正在导入...' : '确定导入' }}
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 积分修改弹窗 -->
        <el-dialog v-model="pointDialogVisible" :title="pointDialogTitle" width="500px" :close-on-click-modal="false">
            <el-form :model="pointForm" :rules="pointRules" ref="pointFormRef" label-width="120px">
                <el-form-item label="积分数量:" prop="pointNum" required>
                    <el-input v-model="pointForm.pointNum" type="number" placeholder="请输入积分数量（正数增加，负数减少）"
                        style="width: 100%;">
                    </el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="pointDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmPointChange" :loading="pointLoading">
                        {{ pointLoading ? '提交中...' : '提交' }}
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 积分日志弹窗 -->
        <el-dialog v-model="pointLogDialogVisible" :title="pointLogDialogTitle" width="1200px"
            :close-on-click-modal="false">
            <div class="point-log-content">
                <!-- 搜索区域 -->
                <div class="search-section">
                    <el-form :inline="true" :model="pointLogSearchForm" class="demo-form-inline">
                        <el-form-item label="积分类型">
                            <el-select v-model="pointLogSearchForm.ruleType" placeholder="请选择积分类型" clearable
                                size="large" style="width: 200px">
                                <el-option label="所有类型" value="" />
                                <el-option v-for="(label, value) in ruleTypeMap" :key="value" :label="label"
                                    :value="value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <div class="button-group">
                                <el-button type="primary" @click="onPointLogSearch" size="large">
                                    <el-icon>
                                        <Search />
                                    </el-icon>搜索
                                </el-button>
                                <el-button @click="resetPointLogSearch" size="large">
                                    <el-icon>
                                        <Refresh />
                                    </el-icon>重置
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 积分日志表格 -->
                <el-table :data="pointLogTableData" style="width: 100%" v-loading="pointLogLoading">
                    <el-table-column prop="nickname" label="群成员" min-width="500">
                        <template #default="scope">
                            {{ scope.row.nickname }} [{{ scope.row.userId }}]
                        </template>
                    </el-table-column>

                    <el-table-column prop="pointNum" label="积分变化" min-width="100" />

                    <el-table-column prop="ruleType" label="积分类型" min-width="100">
                        <template #default="scope">
                            {{ ruleTypeMap[scope.row.ruleType] || scope.row.ruleType }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="userPoint" label="积分余额" min-width="100" />
                    <el-table-column prop="createTime" label="积分时间" min-width="180">
                        <template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
                    </el-table-column>
                </el-table>

                <!-- 分页组件 -->
                <div class="pagination">
                    <el-pagination @size-change="handlePointLogSizeChange" @current-change="handlePointLogCurrentChange"
                        :current-page="pointLogCurrentPage" :page-sizes="[10, 20, 50, 100]"
                        :page-size="pointLogPageSize" layout="total, sizes, prev, pager, next, jumper"
                        :total="pointLogTotal">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>


</template>

<script>
import { Search, Refresh, Upload, Download, ArrowDown } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'MemberManager',
    components: { Search, Refresh, Upload, Download, ArrowDown },
    data() {
        return {
            searchForm: { keyword: '' },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            importVisible: false,
            importLoading: false,
            jsonInput: '',
            previewCount: 0,
            isFormatted: false,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            ruleTypeMap: {
                add: '手动增加',
                sub: '手动减少',
                invite: '邀请',
                sign: '签到',
                textContent: '文字信息',
                photoContent: '图片信息',
                videoContent: '视频信息',
                stickerContent: '贴纸信息',
                redeem: '兑换',
                gameDice: '骰子游戏'
            },
            pointDialogVisible: false,
            pointDialogTitle: '',
            pointLoading: false,
            pointForm: {
                pointNum: 0
            },
            pointRules: {
                pointNum: [{ required: true, message: '请输入积分数量', trigger: 'blur' }]
            },
            currentRow: null,
            currentAction: null,
            pointLogDialogVisible: false,
            pointLogDialogTitle: '',
            pointLogSearchForm: {
                ruleType: ''
            },
            pointLogTableData: [],
            pointLogLoading: false,
            pointLogCurrentPage: 1,
            pointLogPageSize: 10,
            pointLogTotal: 0
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        },
        jsonInput: {
            handler(newValue) {
                if (newValue && newValue.trim()) {
                    this.processJsonInput(newValue);
                } else {
                    this.previewCount = 0;
                }
            },
            immediate: false
        }
    },
    methods: {
        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },
        // 搜索功能
        onSearch() { this.currentPage = 1; this.fetchData(); },
        resetSearch() { this.searchForm = { keyword: '' }; this.currentPage = 1; this.fetchData(); },
        // 获取数据
        async fetchData() {
            this.loading = true;
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    groupid: this.currentUserInfo.groupId,
                };
                if (this.searchForm.keyword) params.keyword = this.searchForm.keyword;
                const response = await api.getMemberManagerList(params);
                if (response.data.code === 0) {
                    this.tableData = response.data.data.records;
                    this.total = response.data.data.total;
                } else {
                    this.$message.error(response.data.message || '获取数据失败');
                }
            } catch (error) {
                console.error('获取成员管理数据失败:', error);
                this.$message.error('获取数据失败');
            } finally {
                this.loading = false;
            }
        },
        handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.fetchData(); },
        handleCurrentChange(val) { this.currentPage = val; this.fetchData(); },

        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            const date = new Date(dateTime);
            return date.toLocaleString('zh-CN');
        },
        // 导入导出相关方法
        handleImport() {
            this.importVisible = true;
            this.jsonInput = '';
            this.previewCount = 0;
            this.isFormatted = false;
        },
        async handleJsonFile(file) {
            // 读取本地json文件内容并填充到textarea
            const reader = new FileReader();
            reader.onload = (e) => {
                this.jsonInput = e.target.result;
                // 自动处理文件内容
                this.processJsonInput(e.target.result);
            };
            reader.onerror = () => {
                this.$message.error('文件读取失败');
            };
            reader.readAsText(file);
            // 阻止el-upload自动上传
            return false;
        },
        processJsonInput(input) {
            if (!input || !input.trim()) {
                this.previewCount = 0;
                return;
            }
            try {
                const data = JSON.parse(input);
                let records = [];

                // 自动识别格式并提取数组
                if (data && typeof data === 'object' && data.data && Array.isArray(data.data.records)) {
                    records = data.data.records;
                } else if (Array.isArray(data.records)) {
                    records = data.records;
                } else if (Array.isArray(data)) {
                    records = data;
                }

                this.previewCount = records.length;

                if (records.length > 0) {
                    // 压缩显示数组数据
                    this.jsonInput = JSON.stringify(records);
                    this.isFormatted = false;
                    this.$message.success(`成功提取 ${records.length} 条数据`);
                } else {
                    this.$message.warning('未识别到有效的数据记录');
                }
            } catch (e) {
                this.previewCount = 0;
                // 如果不是有效JSON，保持原内容不变
            }
        },
        toggleJsonFormat() {
            if (!this.jsonInput) return;

            try {
                const data = JSON.parse(this.jsonInput);
                if (this.isFormatted) {
                    // 压缩显示
                    this.jsonInput = JSON.stringify(data);
                    this.isFormatted = false;
                } else {
                    // 格式化显示
                    this.jsonInput = JSON.stringify(data, null, 2);
                    this.isFormatted = true;
                }
            } catch (e) {
                this.$message.error('JSON 格式不正确');
            }
        },
        async confirmImport() {
            if (!this.jsonInput) {
                this.$message.warning('请粘贴或上传 JSON 数据');
                return;
            }
            let data;
            try {
                data = JSON.parse(this.jsonInput);
            } catch (e) {
                this.$message.error('JSON 格式不正确');
                return;
            }
            // 现在直接是数组数据
            let importData = data;
            if (!Array.isArray(data)) {
                this.$message.error('数据格式错误，请确保是数组格式');
                return;
            }

            // 添加用户信息
            const importPayload = {
                userBot: this.currentUserInfo.userBot,
                groupid: this.currentUserInfo.groupId,
                userid: this.currentUserInfo.userId,
                records: importData
            };

            this.importLoading = true;
            try {
                const response = await api.importMemberManager(importPayload);
                if (response.data.code === 0) {
                    this.$message.success(`成功导入 ${response.data.data.importedCount || response.data.data.length || importData.length} 条数据`);
                    this.importVisible = false;
                    this.fetchData(); // 刷新数据
                } else {
                    this.$message.error(response.data.message || '导入失败');
                }
            } catch (error) {
                console.error('导入失败:', error);
                this.$message.error('导入失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            } finally {
                this.importLoading = false;
            }
        },
        async handleExport() {
            try {
                this.loading = true;
                const params = {
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                };
                const response = await api.exportMemberManager(params);
                if (response.data.code === 0) {
                    // 创建下载链接
                    const blob = new Blob([JSON.stringify(response.data.data, null, 2)], { type: 'application/json' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `member_manager_${new Date().getTime()}.json`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    this.$message.success('导出成功');
                } else {
                    this.$message.error(response.data.message || '导出失败');
                }
            } catch (error) {
                console.error('导出失败:', error);
                this.$message.error('导出失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            } finally {
                this.loading = false;
            }
        },
        handleMute(row, isMute) {
            this.$confirm(`确定要${isMute == 0 ? '禁言' : '解除禁言'}用户 ${row.nickname} [${row.userId}] 吗？`, '确认禁言', {
                confirmButtonText: isMute == 0 ? '确定禁言' : '确定解除禁言',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await api.muteMember({
                        id: row.id,
                        isMute: isMute
                    });
                    if (response.data.code === 0) {
                        this.$message.success('禁言成功');
                        this.fetchData(); // 刷新数据
                    } else {
                        this.$message.error(response.data.message || '禁言失败');
                    }
                } catch (error) {
                    console.error('禁言失败:', error);
                    this.$message.error('禁言失败: ' + (error.response?.data?.message || error.message || '网络错误'));
                }
            }).catch(() => {
                // 用户取消操作
            });
        },
        handleKick(row, isKick) {
            this.$confirm(`确定要${isKick == 0 ? '踢出' : '解封'}用户 ${row.nickname} [${row.userId}] 吗？此操作不可撤销！`, '确认踢出', {
                confirmButtonText: isKick == 0 ? '确定踢出' : '确定解封',
                cancelButtonText: '取消',
                type: 'error'
            }).then(async () => {
                try {
                    const response = await api.kickMember({
                        id: row.id,
                        isKick: isKick
                    });
                    if (response.data.code === 0) {
                        this.$message.success('踢出成功');
                        this.fetchData(); // 刷新数据
                    } else {
                        this.$message.error(response.data.message || '踢出失败');
                    }
                } catch (error) {
                    console.error('踢出失败:', error);
                    this.$message.error('踢出失败: ' + (error.response?.data?.message || error.message || '网络错误'));
                }
            }).catch(() => {
                // 用户取消操作
            });
        },
        async handleMoreCommand(command) {
            const row = command.row;
            if (command.action === 'syncStatus') {
                try {
                    const response = await api.syncMemberStatus({
                        id: row.id
                    });
                    if (response.data.code === 0) {
                        this.$message.success('同步成功');
                        this.fetchData(); // 刷新数据
                    } else {
                        this.$message.error(response.data.message || '同步失败');
                    }
                } catch (error) {
                    console.error('同步失败:', error);
                    this.$message.error('同步失败: ' + (error.response?.data?.message || error.message || '网络错误'));
                }
            } else if (command.action === 'addPoint') {
                this.handleAddPoint(row);
            } else if (command.action === 'subPoint') {
                this.handleSubPoint(row);
            } else if (command.action === 'pointLog') {
                this.handlePointLog(row);
            } else if (command.action === 'setLevel') {
                // this.handleSetLevel(row);
            }
        },

        handleAddPoint(row) {
            this.showPointDialog(row, 'add');
        },
        handleSubPoint(row) {
            this.showPointDialog(row, 'sub');
        },
        showPointDialog(row, action) {
            this.currentRow = row;
            this.currentAction = action;
            this.pointDialogTitle = action === 'add' ?
                `给用户${row.userId}增积分` :
                `给用户${row.userId}减积分`;
            this.pointForm.pointNum = action === 'add' ? 100 : -100; // 默认值
            this.pointDialogVisible = true;
        },
        async confirmPointChange() {
            try {
                await this.$refs.pointFormRef.validate();

                this.pointLoading = true;
                const response = await api.updateMemberPoint({
                    id: this.currentRow.id,
                    pointNum: this.pointForm.pointNum
                });

                if (response.data.code === 0) {
                    const actionText = this.pointForm.pointNum > 0 ? '增加' : '减少';
                    this.$message.success(`${actionText}积分成功`);
                    this.pointDialogVisible = false;
                    this.fetchData(); // 刷新数据
                } else {
                    this.$message.error(response.data.message || '积分修改失败');
                }
            } catch (error) {
                console.error('积分修改失败:', error);
                this.$message.error('积分修改失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            } finally {
                this.pointLoading = false;
            }
        },
        handlePointLog(row) {
            this.currentRow = row; // 保存当前行数据
            this.pointLogDialogVisible = true;
            this.pointLogDialogTitle = `用户 ${row.nickname} [${row.userId}] 的积分日志`;
            this.pointLogCurrentPage = 1;
            this.pointLogPageSize = 10;
            this.pointLogSearchForm.ruleType = ''; // 重置搜索条件
            this.fetchPointLogData();
        },
        async fetchPointLogData() {
            this.pointLogLoading = true;
            try {
                const params = {
                    userId: this.currentRow.userId,
                    page: this.pointLogCurrentPage,
                    pageSize: this.pointLogPageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                };
                if (this.pointLogSearchForm.ruleType) params.ruleType = this.pointLogSearchForm.ruleType;

                const response = await api.getMemberPointLog(params);
                if (response.data.code === 0) {
                    this.pointLogTableData = response.data.data.records;
                    this.pointLogTotal = response.data.data.total;
                } else {
                    this.$message.error(response.data.message || '获取积分日志失败');
                }
            } catch (error) {
                console.error('获取积分日志失败:', error);
                this.$message.error('获取积分日志失败: ' + (error.response?.data?.message || error.message || '网络错误'));
            } finally {
                this.pointLogLoading = false;
            }
        },
        handlePointLogSizeChange(val) {
            this.pointLogPageSize = val;
            this.fetchPointLogData();
        },
        handlePointLogCurrentChange(val) {
            this.pointLogCurrentPage = val;
            this.fetchPointLogData();
        },
        onPointLogSearch() {
            this.pointLogCurrentPage = 1;
            this.fetchPointLogData();
        },
        resetPointLogSearch() {
            this.pointLogSearchForm.ruleType = '';
            this.pointLogCurrentPage = 1;
            this.fetchPointLogData();
        },
        handleSetLevel(row) {
            this.$message.info(`指定等级功能开发中，当前行数据: ${JSON.stringify(row)}`);
        },
        getStatusType(status) {
            switch (status) {
                case 'administrator':
                    return 'success'; // 管理员
                case 'creator':
                    return 'success'; // 创建者
                case 'member':
                    return 'info'; // 普通成员
                case 'left':
                    return 'danger'; // 已离开
                case 'kicked':
                    return 'danger'; // 已封禁
                default:
                    return 'info'; // 默认
            }
        },
        getStatusText(status) {
            switch (status) {
                case 'administrator':
                    return '管理员';
                case 'creator':
                    return '创建者';
                case 'member':
                    return '普通成员';
                case 'left':
                    return '已离开';
                case 'kicked':
                    return '已封禁';
                default:
                    return '未知';
            }
        }
    },
    mounted() {
        // 
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
        }

    }
}
</script>

<style scoped>
.bot-manager {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.el-divider {
    margin: 20px 0;
}

.operation-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.operation-buttons .el-button {
    margin-right: 0;
}

.point-log-content {
    display: flex;
    flex-direction: column;
    height: 700px;
    /* Adjust height as needed */
    overflow-y: auto;
}
</style>